/* Steady Freddy — ED Approval Page Logic (Australia) */
(function () {
  "use strict";

  // Get checkout URL from section settings or use default
  var CHECKOUT_URL = window.SF_CHECKOUT_URL || "/cart/47742428151971:1";

  var ans = {};
  try { ans = JSON.parse(localStorage.getItem("sf_ed_quiz")) || {}; } catch (e) {}

  // ══════ Personalize name ══════
  var first = ans.name ? String(ans.name).trim().split(/\s+/)[0] : "";
  if (first) {
    var headline = document.getElementById("apHeadline");
    if (headline) headline.innerHTML = first + ", <em>you're pre-approved</em>";
  }

  // ══════ Personalize plan from answers ══════
  var format = ans.format_preference;
  var goal = ans.goal;
  var frequency = ans.frequency;

  var planName = "Your Treatment Plan";
  var planTag = "Recommended for you";
  var med = "Prescription treatment";
  var fmt = "As recommended by doctor";
  var onset = "Varies by treatment type";
  var bestFor = "Tailored to your needs";
  var desc = "A comprehensive treatment approach tailored to your health profile and goals — adjustable with your physician any time.";

  // Logic to determine plan
  if (format === "daily" || goal === "long" || goal === "spontaneous" || frequency === "regular") {
    planName = "Your Treatment Plan";
    med = "Prescription treatment";
    fmt = "As recommended by doctor";
    onset = "Varies by treatment type";
    bestFor = goal === "long" ? "Extended treatment window" : goal === "spontaneous" ? "Flexible dosing" : "Regular use";
    desc = "A treatment approach tailored to your health profile and lifestyle preferences — determined by your doctor.";
  } else if (goal === "minimal_sides") {
    bestFor = "Personalized approach";
    desc = "A treatment approach your physician will tailor based on your individual health profile and preferences.";
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  setText("apPlanName", planName);
  setText("apPlanTag", planTag);
  setText("apPlanDesc", desc);
  setText("apSpecMed", med);
  setText("apSpecFormat", fmt);
  setText("apSpecOnset", onset);
  setText("apSpecGoal", bestFor);

  // ══════ Checkout links ══════
  ["apCheckout", "apCheckout2"].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.setAttribute("href", CHECKOUT_URL);
  });

  // ══════ Countdown timer ══════
  var KEY = "sf_ed_approval_expiry";
  var now = Date.now();
  var expiry = parseInt(localStorage.getItem(KEY), 10);
  if (!expiry || isNaN(expiry) || expiry < now) {
    expiry = now + 10 * 60 * 1000; // 10 minutes
    localStorage.setItem(KEY, String(expiry));
  }

  var timerEl = document.getElementById("apTimer");
  var barText = document.getElementById("apBarText");

  function tick() {
    var left = Math.max(0, expiry - Date.now());
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    if (timerEl) timerEl.textContent = m + ":" + (s < 10 ? "0" : "") + s;
    if (left <= 0) {
      if (timerEl) timerEl.textContent = "0:00";
      if (barText) barText.textContent = "Your reserved price is held — check out now";
      return;
    }
    requestAnimationFrame(function () { setTimeout(tick, 250); });
  }
  tick();

  // ══════ FAQ ══════
  var FAQS = [
    ["What exactly am I paying $20 for?", "The $20 AUD is a one-time consultation fee. It covers a full review by an AHPRA-registered Australian doctor and a personalised treatment plan. Medication, if you're approved and choose to proceed, is billed separately."],
    ["Is the $20 refundable?", "Yes. If you're not approved, or the plan isn't right for you, our team will adjust it or refund your consultation under our satisfaction guarantee."],
    ["When will I get my prescription?", "Most patients are reviewed within 24-48 hours. If approved, your prescription will be sent to your preferred pharmacy for collection."],
    ["Is this private and secure?", "Completely. Your information is protected under Australian privacy laws, and checkout is SSL-secured."],
    ["Can I cancel anytime?", "Yes — there's no lock-in. You can adjust your treatment plan with your doctor whenever you need."]
  ];

  var list = document.getElementById("apFaqList");
  if (list) {
    FAQS.forEach(function (pair) {
      var item = document.createElement("div");
      item.className = "ed-faq__item";
      item.innerHTML =
        '<button class="ed-faq__q" aria-expanded="false">' + pair[0] +
        '<span class="ed-faq__q-icon" aria-hidden="true">+</span></button>' +
        '<div class="ed-faq__a"><div class="ed-faq__a-inner">' + pair[1] + '</div></div>';
      var btn = item.querySelector(".ed-faq__q");
      var aBox = item.querySelector(".ed-faq__a");
      btn.addEventListener("click", function () {
        var open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        aBox.style.maxHeight = open ? aBox.scrollHeight + "px" : "0px";
      });
      list.appendChild(item);
    });
  }

  if (window.lucide) lucide.createIcons();

  // ══════ Sticky CTA Banner ══════
  var stickyCta = document.getElementById("apStickyCta");
  var heroSection = document.querySelector(".ap-hero");
  
  function updateStickyCta() {
    if (!stickyCta || !heroSection) return;
    var heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrolled > heroBottom) {
      stickyCta.classList.add("is-visible");
    } else {
      stickyCta.classList.remove("is-visible");
    }
  }
  
  window.addEventListener("scroll", updateStickyCta);
  window.addEventListener("resize", updateStickyCta);
  updateStickyCta();

  // Checkout buttons now use direct cart links

})();
